import PlayerCard from "./PlayerCard/PlayerCard.jsx";
import MainHeader from "../MainHeader/MainHeader.js";
import React from "react";
import {
  getUserEmail,
  getNameToDisplay,
  isLoggedIn,
  redirectToSignin,
  findSportByLeague,
} from "../../utils/utils.js";
import SkeletonLoader from "../Skeleton/SkeletonLoader.js";
import {
  setLeague,
  setMatchDatetime,
  setSelectedTimeframe,
  signoutRequest,
} from "../../redux/GameInformation/GameInformationAction.js";
import { connect } from "react-redux";
import TagManager from "react-gtm-module";
import AppJS from "../../assets/app/AppJS.js";
import AppCSS from "../../assets/app/AppCSS.js";
import { Helmet } from "react-helmet";
import {
  fetchRemoteConfigFailure,
  fetchRemoteConfigRequest,
  fetchRemoteConfigSuccess,
} from "../../redux/RemoteConfig/RemoteConfigAction.js";
import {
  askForPermissionToReceiveNotifications,
  getID,
  remoteConfig,
} from "../../firebase.js";
import {
  getUserMetaData,
  insertUserMetaData,
  updateTourStateInUserMetaData,
} from "../../firestoreQueries.js";
import { Redirect } from "react-router";

function Content(props) {
  const [loginStatus, setLoginStatus] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(true);
  const [userEmail, setUserEmail] = React.useState(null);
  
  React.useEffect(() => {
    const fetchConfig = () => {
      console.log("Fetch Config Called");
      props.fetchConfigRequest();
      remoteConfig
      .fetchAndActivate()
      .then(() => {
        console.log("Fetch And Activate Complete");
        const configValues = remoteConfig.getAll();
        props.fetchConfigSuccess(configValues);
      })
      .catch((error) => {
        props.fetchConfigFailure(error);
        console.log("Fetch And Activate Failed");
      });
    };
    
    fetchConfig(); // Fetch immediately on component mount
    const intervalId = setInterval(fetchConfig, 3600000); // Fetch every hour
    
    return () => clearInterval(intervalId); // Cleanup on component unmount
  }, [
    props.fetchConfigRequest,
    props.fetchConfigSuccess,
    props.fetchConfigFailure,
  ]);
  React.useEffect(() => {
    document.title = "Home";
    console.log(
      "Content go_back_boolean: ",
      props.content_info.gameInformationReducer.got_api_data
      );
      remoteConfig
      .fetchAndActivate()
      .then(() => {
        let rcConfig = {
          config: remoteConfig.getAll()
        };
        isLoggedIn("content")
        .then(async (resp) => {
          console.log("content:: resp:: " + resp);
          if (resp === true) {
            // handling the case when redux league is removed from remoteConfig
            // if it's undefined: then reset all the states
            if(props.content_info.gameInformationReducer.sports !== null){
              const sport = findSportByLeague(props.content_info.gameInformationReducer.sports, rcConfig, "isLoggedIn ContentJSX");
              if (sport === undefined) {
                props.reset_state();
              }
            }
            else{
              console.log("No sport selected")
            }
            
            const email = await getUserEmail();
            const userId = getID();
            console.log("Content: " + email + " userID: " + userId);
            const userMetadata = await getUserMetaData(email);
            console.log("user metadata from firebase:: ", userMetadata);
            // // check if there is a userMetadata
            if (userMetadata.empty) {
              const metaDataToAdd = {
                userID: userId,
                email: email,
                preferences: {
                  web: {
                    isFirstTimeUserGuideVisible: true,
                  },
                  android: null,
                },
              };
              
              console.log("user metadata to add:: ", metaDataToAdd);
              const metadataResp = insertUserMetaData(metaDataToAdd);
              console.log("user metadata added:: ", metadataResp);
              console.log("user metadata:: ", userMetadata.data());
            } else {
              console.log(
                "user metadata content js where debug:: ",
                userMetadata.docs[0].data().preferences
                );
                const preferences = userMetadata.docs[0].data().preferences;
                console.log("user metadata content js where debug:: ", preferences);
                
                // check for web
                if (preferences.web === null) {
                  console.log(
                    "user metadata web:: ",
                    preferences.web
                    );
                    // update the record with web: { isFirstTimeUserGuideVisible: true }
                    await updateTourStateInUserMetaData(email, true);
                  } else {
                    console.log("web not null, ", preferences.web);
                  }
                  
                  // check for web
                  // if (userMetadata.docs[0].data.preferences.web === null) {
                  //   console.log("user metadata web:: ", userMetadata.data().preferences.web);
                  //   // update the record with web: { isFirstTimeUserGuideVisible: true }
                  //   await updateTourStateInUserMetaData(email, true);
                  // } else {
                  //   console.log("web not null, ", userMetadata.docs[0].preferences.web)
                  // }
                }
                
                if (process.env.REACT_APP_ENV === "production") {
                  TagManager.dataLayer({
                    dataLayer: {
                      event: "pageview",
                      userId: userId,
                    },
                  });
                }
                
                if (!props.content_info.gameInformationReducer.got_api_data) {
                  console.groupCollapsed("-- Main Header State Updation --");
                  props.updateLeague(null);
                  props.updateSelectedTimeframe(null);
                  props.updateMatchDatetime(null);
                  console.groupEnd();
                }
                const nameToDisplay = getNameToDisplay(email);
                
                console.log("Email to save: ", nameToDisplay);
                setUserEmail(nameToDisplay);
                setLoginStatus(true);
                
                setShowLoader(false);
              } else {
                console.log("Content:: user not logged in");
                setLoginStatus(false);
                setShowLoader(false);
              }
              await askForPermissionToReceiveNotifications();
            })
            .catch(() => {
              setLoginStatus(false);
              setShowLoader(false);
            });
          })
          .catch((error) => {
            isLoggedIn("content")
            .then(async (resp) => {
              console.log("content:: resp:: " + resp);
              if (resp === true) {
                // handling the case when redux league is removed from remoteConfig
                // if it's undefined: then reset all the states
                if(props.content_info.gameInformationReducer.sports !== null){
                  const sport = findSportByLeague(props.content_info.gameInformationReducer.sports, props.remoteConfig, "isLoggedIn ContentJSX");
                  if (sport === undefined) {
                    props.reset_state();
                  }
                }
                else{
                  console.log("No sport selected")
                }
                
                const email = await getUserEmail();
                const userId = getID();
                console.log("Content: " + email + " userID: " + userId);
                const userMetadata = await getUserMetaData(email);
                console.log("user metadata from firebase:: ", userMetadata);
                // // check if there is a userMetadata
                if (userMetadata.empty) {
                  const metaDataToAdd = {
                    userID: userId,
                    email: email,
                    preferences: {
                      web: {
                        isFirstTimeUserGuideVisible: true,
                      },
                      android: null,
                    },
                  };
                  
                  console.log("user metadata to add:: ", metaDataToAdd);
                  const metadataResp = insertUserMetaData(metaDataToAdd);
                  console.log("user metadata added:: ", metadataResp);
                  console.log("user metadata:: ", userMetadata.data());
                } else {
                  console.log(
                    "user metadata content js where debug:: ",
                    userMetadata.docs[0].data().preferences
                    );
                    const preferences = userMetadata.docs[0].data().preferences;
                    console.log("user metadata content js where debug:: ", preferences);
                    
                    // check for web
                    if (preferences.web === null) {
                      console.log(
                        "user metadata web:: ",
                        preferences.web
                        );
                        // update the record with web: { isFirstTimeUserGuideVisible: true }
                        await updateTourStateInUserMetaData(email, true);
                      } else {
                        console.log("web not null, ", preferences.web);
                      }
                      
                      // check for web
                      // if (userMetadata.docs[0].data.preferences.web === null) {
                      //   console.log("user metadata web:: ", userMetadata.data().preferences.web);
                      //   // update the record with web: { isFirstTimeUserGuideVisible: true }
                      //   await updateTourStateInUserMetaData(email, true);
                      // } else {
                      //   console.log("web not null, ", userMetadata.docs[0].preferences.web)
                      // }
                    }
                    
                    if (process.env.REACT_APP_ENV === "production") {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: "pageview",
                          userId: userId,
                        },
                      });
                    }
                    
                    if (!props.content_info.gameInformationReducer.got_api_data) {
                      console.groupCollapsed("-- Main Header State Updation --");
                      props.updateLeague(null);
                      props.updateSelectedTimeframe(null);
                      props.updateMatchDatetime(null);
                      console.groupEnd();
                    }
                    const nameToDisplay = getNameToDisplay(email);
                    
                    console.log("Email to save: ", nameToDisplay);
                    setUserEmail(nameToDisplay);
                    setLoginStatus(true);
                    
                    setShowLoader(false);
                  } else {
                    console.log("Content:: user not logged in");
                    setLoginStatus(false);
                    setShowLoader(false);
                  }
                  await askForPermissionToReceiveNotifications();
                })
                .catch(() => {
                  setLoginStatus(false);
                  setShowLoader(false);
                });
              });
            }, []);
            return (
              <>
              <Helmet>
              <link rel="canonical" href="https://www.spontasy.com/app" />
              </Helmet>
              <AppJS />
              <AppCSS />
              {showLoader ? (
                <SkeletonLoader number_of_cards={6} />
                ) : loginStatus ? (
                  <>
                  <div className="content__main">
                  <MainHeader userEmail={userEmail} isAdmin={false} />
                  <PlayerCard className="card__main" />
                  </div>
                  </>
                  ) : (
                    redirectToSignin()
                    )}
                    </>
                    );
                  }
                  
                  const mapStateToProps = (state) => {
                    return {
                      content_info: state,
                      remoteConfig: state.rcReducer
                    };
                  };
                  
                  const mapDispatchToProps = (dispatch) => {
                    return {
                      updateLeague: (value) => dispatch(setLeague(value)),
                      updateSelectedTimeframe: (value) => dispatch(setSelectedTimeframe(value)),
                      updateMatchDatetime: (value) => dispatch(setMatchDatetime(value)),
                      fetchConfigRequest: () => dispatch(fetchRemoteConfigRequest()),
                      fetchConfigSuccess: (configValues) =>
                      dispatch(fetchRemoteConfigSuccess(configValues)),
                      fetchConfigFailure: (error) => dispatch(fetchRemoteConfigFailure(error)),
                      reset_state: () => dispatch(signoutRequest()),
                    };
                  };
                  
                  export default connect(mapStateToProps, mapDispatchToProps)(Content);
                  